import { getSiteBrand } from "@/lib/siteHosts";

const brandName = () => getSiteBrand().name;

export const INTERCEPT_HERO = {
  badge: "INTERCEPT PROTOCOL // AGENCY BRIEFING",
  get headline() {
    return `If your clients aren't running ${brandName()}, our infrastructure is already intercepting their leads.`;
  },
  get headlineLine1() {
    return `If your clients aren't running ${brandName()},`;
  },
  headlineLine2Lead: "our infrastructure is already ",
  headlineLine2Accent: "intercepting their leads.",
  subline:
    "Every after-hours click your campaigns buy can fund a competitor's client. If your client's stack doesn't respond in seconds, you eat the churn. Not them.",
  cta: "See How It Works",
  ctaTarget: "leaked-lead",
};
